import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Drawer, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText, 
  ListItemButton, 
  IconButton, 
  Box, 
  Divider, 
  useTheme, 
  useMediaQuery,
  Button,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const AppNavigation = ({ 
  selectedApp, 
  setSelectedApp, 
  showAllApps, 
  setShowAllApps, 
  APP_LIST,
  handleLogout,
  setLoading,
  loading
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    if (!loading) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleAppSelect = (appId) => {
    if (!loading) {
      setSelectedApp(appId);
      setShowAllApps(false);
      if (isMobile) {
        setMobileOpen(false);
      }
    }
  };

  const handleAllAppsSelect = () => {
    if (!loading) {
      setShowAllApps(true);
      if (isMobile) {
        setMobileOpen(false);
      }
    }
  };

  const drawer = (
    <Box 
      sx={{
        height: "calc(100vh - 100px)",
        borderBottomLeftRadius: "20px",
        borderBottomRightRadius: "20px",
        backgroundColor: "white",
        overflow: "hidden",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        display: "flex",
        flexDirection: "column",
      }}
    >
          <Divider
            sx={{
              bgcolor: '#D9D9D9',
              marginInline: '8px',
              height: '0.5px',
            }}
          />

          <Box sx={{ flexGrow: 1, overflowY: 'visible' }}>
            <List>
              <ListItem disablePadding>
                <ListItemButton
                  selected={showAllApps}
                  onClick={handleAllAppsSelect}
                  disabled={loading}
                >
                  <ListItemIcon>
                    <Box
                      component="img"
                      src="/icons/all-apps-dashboard.png"
                      alt="apps"
                      sx={{
                        width: 32,
                        height: 32,
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="All Apps Dashboard" />
                </ListItemButton>
              </ListItem>

              {APP_LIST.map((app) => (
                <ListItem key={app.id} disablePadding>
                  <ListItemButton
                    selected={selectedApp === app.id && !showAllApps}
                    onClick={() => handleAppSelect(app.id)}
                    disabled={loading}
                  >
                    <ListItemIcon>
                      <img
                        src={app.icon}
                        alt={app.name}
                        style={{
                          width: 28,
                          height: 28,
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={app.name}
                      sx={{
                        color:
                          selectedApp === app.id && !showAllApps
                            ? '#000000'
                            : '#7588B7',
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>

          {/* Fixed Logout Button at the Bottom */}
          <Button
            color="primary"
            onClick={handleLogout}
            sx={{ 
              fontSize: '16px',
              marginTop: 'auto',
              marginInline: '5px',
              marginBottom: '15px',
              height: '48px',
              backgroundColor: "#EFF3FE",        
              color: "#7588B7",
              borderRadius: "20px",              
              textTransform: "none",
              justifyContent: "flex-start", 
              display: "flex",
              gap: 1.5,
              "&:hover": {
                backgroundColor: "rgba(25,118,210,0.08)",      
              },
            }}
            disabled={loading}
          >
            <Box
              component="img"
              src="/icons/logout-button.png"             
              alt="logout"
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",             
                objectFit: "cover",
              }}
            />
            Log Out
          </Button>
    </Box>
);

  const drawerWidth = 240;

  return (
    <>
        <>
          {/* AppBar for mobile */}
          {isMobile && (
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
              <Toolbar>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2 }}
                  disabled={loading}
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" noWrap component="div">
                  {showAllApps
                    ? 'All Apps Dashboard'
                    : `${APP_LIST.find((app) => app.id === selectedApp)?.name} Dashboard`}
                </Typography>
              </Toolbar>
            </AppBar>
          )}
  
          {/* Side Drawer */}
          <Box
            component="nav"
            sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
          >
            {isMobile ? (
              <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{ keepMounted: true, disableEscapeKeyDown: loading, disableBackdropClick: loading }}
                sx={{
                  '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, borderRight: 'none',  boxShadow: 'none',   },
                  
                }}
              >
                {drawer}
              </Drawer>
            ) : (
              drawer
            )}
          </Box>
  
          {/* Main content spacer for mobile */}
          {isMobile && <Toolbar />}
        </>
    </>
  );
};

export default AppNavigation;